import React from 'react';
import { Field } from 'react-final-form';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import LabelWithContent from '../../Fields/LabelWithContent/LabelWithContent';
import Popover from '../../Popover/Popover';
import RegularPopover from './Popovers/Regular';
import ImagePopover from './Popovers/WithImage';
import Input from '../../Fields/Input/Input';
import HuHintImage from '../../../images/next_hu.png';
import NumberOfOwnersImage from '../../../images/number_of_owners.png';
import MonthPicker from '../../Fields/monthPicker/MonthPicker';
import SwitchContent from '../../Fields/SwichContent/SwitchContent';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const FieldLabel = ({ label, title, description, }) => {
  return (
    <LabelWithContent
      label={label}
      content={
        <Popover
          wrapperStyle={{ marginLeft: 5, }}
          content={
            <RegularPopover
              title={title}
              description={description}
            />
          }
        />
      }
    />
  );
};

const FieldLabelWithImage = ({ label, title, description, imgTitle, imgSrc, }) => {
  return (
    <LabelWithContent
      label={label}
      content={
        <Popover
          wrapperStyle={{ marginLeft: 5, }}
          content={
            <ImagePopover
              title={title}
              description={description}
              imgTitle={imgTitle}
              imgSrc={imgSrc}
            />
          }
        />
      }
    />
  );
};

const AdNewFormService = (props) => {
  const { t, newInspection, } = props;
  const styles = useStyles();
  const nextHuTooltipImageTitle = (
    <span className={styles.tooltipWrapper}>
      {`${t('next_hu_tooltip_image_title')} `}
      <span className={styles.tooltipDetail}>{t('next_hu_tooltip_image_title_teil1')}</span>
    </span>
  );
  const numberOfOwnersTooltipImageTitle = (
    <span className={styles.tooltipWrapper}>
      {`${t('next_hu_tooltip_image_title')} `}
      <span className={styles.tooltipDetail}>
        {t('number_of_previous_owners_tooltip_image_title_teil2')}
      </span>
    </span>
  );
  const vinTooltipImageTitle = (
    <span className={styles.tooltipWrapper}>
      {`${t('vin_tooltip_image_title')} `}
    </span>
  );

  return (
    <div className={styles.container}>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('ful_service_history')}
            title={t('ful_service_history')}
            description={t('last_inspection_tooltip_description')}
          />
        </div>
        <SwitchContent name="ful_service_history" />
      </div>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('new_inspection')}
            title={t('new_inspection')}
            description={t('last_inspection_tooltip_description')}
          />
        </div>
        <SwitchContent name="new_inspection" />
      </div>
      <br />
      <div className={styles.row}>
        <div className={styles.leftColumn}>
          <div>
            <FieldLabel
              label={t('last_inspection')}
              title={t('last_inspection')}
              description={t('last_inspection_tooltip_description')}
            />
            <Field
              component={MonthPicker}
              name="last_inspection"
              id="last_inspection"
            />
          </div>
        </div>
        <div className={styles.rightColumn}>
          {!newInspection &&
            <div>
              <FieldLabelWithImage
                label={t('next_hu')}
                title={t('next_hu')}
                description={t('next_hu_tooltip_description')}
                imgTitle={nextHuTooltipImageTitle}
                imgSrc={HuHintImage}
              />
              <Field
                component={MonthPicker}
                name="next_hu"
                id="next_hu"
              />
            </div>
          }
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('first_registration')}
            title={t('first_registration')}
            description={t('first_registration_tooltip_description')}
          />
          <Field
            name="first_registration"
            component={MonthPicker}
          />
        </div>
        <div className={styles.rightColumn}>
          <FieldLabel
            label={t('total_mileage')}
            title={t('total_mileage')}
            description={t('total_mileage_tooltip_description')}
          />
          <Field component={Input} name="total_mileage" hideMessages type="number" />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.leftColumn}>
          <FieldLabelWithImage
            label={t('vin')}
            title={t('vin')}
            description={t('vin_tooltip_title')}
            imgTitle={vinTooltipImageTitle}
            imgSrc={NumberOfOwnersImage}
          />
          <Field component={Input} hideMessages name="vin" type="text" />
        </div>
        <div className={styles.rightColumn}>
          <FieldLabelWithImage
            label={t('number_of_previous_owners')}
            title={t('number_of_previous_owners')}
            description={t('number_of_previous_owners_tooltip_description')}
            imgTitle={numberOfOwnersTooltipImageTitle}
            imgSrc={NumberOfOwnersImage}
          />
          <Field
            component={Input}
            name="number_of_previous_owners"
            hideMessages
            type="number"
            customClass="super-short-input"
          />
        </div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    padding: '0 15px',
  },
  row: {
    marginBottom: 15,
    flexWrap: 'wrap',
    positoin: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftColumn: {
    paddingLeft: 0,
    width: 'clamp(350px, 48%, 100vh)',

  },
  rightColumn: {
    paddingRight: 0,
    width: 'clamp(350px, 48%, 100vh)',
  },
  tooltipWrapper: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 16,
  },
  tooltipDetail: {
    marginLeft: 10,
    color: '#faaF3a',
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 15,
    borderBottom: '2px solid #f6f5f8',
    '&:not(:first-of-type)': {
      paddingTop: 15,
    },
  },
  '@media screen and (max-width: 720px)': {
    leftColumn: {
      padding: 0,
    },
    rightColumn: {
      paddingTop: 15,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

FieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

FieldLabelWithImage.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imgTitle: PropTypes.element.isRequired,
  imgSrc: PropTypes.node.isRequired,
};

AdNewFormService.propTypes = {
  t: PropTypes.func.isRequired,
  newInspection: PropTypes.bool.isRequired,
};


export default withScopedTranslations('ad_vehicle_description')(AdNewFormService);
